import {delay} from '@yandex-delivery/utils'

import {ServerError} from '../ServerError'
import {type TypedRequestConfig, FetchFunction} from '../types'
const ERROR_MESSAGE = 'Request has been terminated'
const MAX_RETRY_COUNT = 3

export type CustomError = {
  customErrorMessage: string
}

export function withRequestHasBeenTerminatedRetry({customErrorMessage}: CustomError) {
  return function _withRequestHasBeenTerminatedRetry<
    TReq = unknown,
    TRes = unknown,
    TExtraConfig extends Record<string, unknown> = {},
  >(fetchFunc: FetchFunction<TReq, TRes, TExtraConfig>) {
    return function enhancedFetch(config: TypedRequestConfig<TReq, TRes> & TExtraConfig) {
      const retry = async (attempt: number = 0): ReturnType<FetchFunction<TReq, TRes, TExtraConfig>> => {
        try {
          return await fetchFunc(config)
        } catch (error: unknown) {
          if (error instanceof ServerError) {
            const isRequestHasBeenTerminatedError = error.status === 0 && error.message.includes(ERROR_MESSAGE)

            if (isRequestHasBeenTerminatedError && attempt < MAX_RETRY_COUNT) {
              return delay(1000).then(() => retry(attempt + 1))
            }

            throw isRequestHasBeenTerminatedError
              ? new Error(customErrorMessage || 'Кажется, что-то пошло не так! Попробуйте обновить страницу')
              : error
          } else {
            throw error
          }
        }
      }

      return retry()
    }
  }
}
